/** User */
export const SET_RETRY = "SET_RETRY";
export const SET_USER = "SET_USER";
export const SET_ERROR = "SET_ERROR";
export const RESET_USER = "RESET_USER";

export const SET_MODAL = "SET_MODAL";
